export enum supplyTypeEnum {
  FGP线下 = 0,
  OEM = 1,
  FGP线上 = 4,
  IPD = 5,
  ODM = 6,
  VMI = 7,
}
